import cn from "classnames";
import { pillClass } from "./ScaleQuestion";

interface Props {
  value: number | undefined;
  onChange: (value: number) => void;
}

const NpsQuestion: React.FC<Props> = ({ value, onChange }) => (
  <div>
    <div className="grid grid-cols-6 sm:grid-cols-11 gap-1.5" role="radiogroup">
      {Array.from({ length: 11 }, (_, v) => (
        <button
          key={v}
          type="button"
          role="radio"
          aria-checked={value === v}
          onClick={() => onChange(v)}
          className={cn(pillClass(value === v), "h-10")}
        >
          {v}
        </button>
      ))}
    </div>
    <div className="mt-2 flex justify-between text-[11px] text-base-content/50">
      <span>Not likely</span>
      <span>Very likely</span>
    </div>
  </div>
);

export default NpsQuestion;
